/**
 * Checks if both current and next block types are 'TEXT'.
 * @param {String} currentType Current block type.
 * @param {String} nextType Next block type.
 * @returns {Boolean}
 */
const isBetweenTwoTextBlocks = ({ currentType, nextType }) => (
  currentType === 'TEXT' && nextType === 'TEXT'
);

export default isBetweenTwoTextBlocks;
